import { useDispatch, useSelector } from "react-redux";
import { dispatchHandler } from "../apiHelperFunctions";
import { useEffect } from "react";
import { getPermissionKey } from "../permissions";

// Custom Hook : To Acess Vendor portal
export const useAcessVendorPortal = () => {
    const dispatch = useDispatch();

    const accessVendorPortalData = useSelector(state => state?.masterDbStore?.accessVendorPortalData);

    useEffect(() => {
        if(accessVendorPortalData?.isSuccess){
            let url = "/#/?accessVendorPortalToken=" + accessVendorPortalData?.data?.resource?.token
			window.open(url);
        }
    },[accessVendorPortalData])

    const accessVendorPortal = (config = {}) => {
        let {
            username,
        } = config || {};
    
        let payload = {
            username: username,
            token: sessionStorage.getItem("token")
        }
    
        dispatchHandler(dispatch, "accessVendorPortalRequest", payload);
    }

    return accessVendorPortal;
}